export default {
  priv: 'manage',
  overviewTitle: 'Groepen',
  detailTitle: 'Groep',
  deleteTitle: 'deze Groep',
  url: '/manage/userroles',
  apiUrl: '/userroles/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'manage/userroles',
  quickFilter: {
    text: 'Zoek op name',
    value: 'name',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(context, item) {
  //   return false;
  // },
  // customDeletable(context, item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Name', value: 'name', link: '/manage/userroles/{id}', width: '10%'},
    {text: 'Naam', value: 'name_nl', width: '10%'},
    {text: 'Manage', value: 'manage', width: '10%'},
    {text: 'TrajectControle Keuring', value: 'inspection_tc', width: '10%'},
    {text: 'Site Keuring', value: 'inspection_site', width: '10%'},
    {text: 'Lijst Keurder', value: 'is_inspector', type: 'boolean', width: '7.5%'}
  ]
};
